import {connect} from 'react-redux'
import { compose } from "redux"
import QuestionsPage from "../components/questions-page"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import { graphql } from "react-apollo";
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setSubmitError } from "../actions/survey";
import {QUESTIONNAIRE_FRAGMENT} from "../graphql/fragments";

const query = gql`
  query QuestionsPage($languageCode: String) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const store = gql`
  mutation AnswerOrSkipLikertQuestion(
    $answer: LikertQuestionAnswerInput!
    $languageCode: String
  ) {
    answerOrSkipLikertQuestion(answer: $answer, languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const storeOpenQuestion = gql`
  mutation AnswerOrSkipOpenQuestion(
    $answer: OpenQuestionAnswerInput!
    $languageCode: String
  ) {
    answerOrSkipOpenQuestion(answer: $answer, languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const rateQuestion = gql`
  mutation RateLikertQuestion(
    $rate: LikertQuestionRateInput!
    $languageCode: String
  ) {
    rateLikertQuestion(rate: $rate, languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const mapStateToProps = (
  { survey: { submitError } }
) => {
  return {
    submitError,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error))
    },
  }
}

export default compose(
  withTranslations,
  withData(query, {
    options: (props) => {
      return {
        ...getVariables(props),
        fetchPolicy: "cache-first",
      };
    },
  }),
  connect(mapStateToProps, mapDispatchToProps),
  graphql(store, { name: "answerQuestion" }),
  graphql(storeOpenQuestion, { name: "answerOpenQuestion" }),
  graphql(rateQuestion, { name: "rateQuestion" })
)(QuestionsPage);



// WEBPACK FOOTER //
// ./src/containers/questions-page.js